import styled from 'styled-components';
import Colors from '../../constants/Colors';

const diffColors = {
  pos: '#2bb756',
  neg: '#e66330',
  zero: '#909090',
};

const ListCon = styled.div`
  height: 700px;
  background: #434854;
`;

const Item = styled.div`
  margin-bottom: 1px;
  background: ${Colors.darkSteel};
  display: grid;
  grid-template-columns: 50px 1fr 1fr 1fr;
  grid-template-areas:
    'logo symbol btcprice diff'
    'logo volume usdprice diff';
  color: #fff;
  align-items: center;
`;

const Logo = styled.div`
  grid-area: logo;
  align-self: center;
  justify-self: center;
  img {
    display: block;
    width: 32px;
    height: 32px;
  }
`;

const Rank = styled.div`
  grid-area: rank;
  text-align: center;
`;

const Symbol = styled.div`
  grid-area: symbol;
  margin-top: 5px;
  line-height: 25px;
`;
const Volume24 = styled.div`
  font-size: 12px;
  color: #aaa;
  line-height: 20px;
`;

const BtcPrice = styled.div`
  grid-area: btcprice;
  margin-top: 5px;
  line-height: 25px;
`;

const UsdPrice = styled.div`
  grid-area: usdprice;
  font-size: 13px;
  color: #aaa;
  line-height: 20px;
`;

const Diff = styled.div`
  grid-area: diff;
  padding: 6px 0;
  margin: 0 10px;
  border-radius: 2px;
  text-align: center;
  font-size: 12px;
  background: ${({ diff }: { diff: string }) => diffColors[diff]};
`;

export { ListCon, Item, Logo, Rank, Symbol, Volume24, BtcPrice, UsdPrice, Diff };



// WEBPACK FOOTER //
// ./src/components/Favorites/FavItem.tsx